class ProductFormNavActions {

	// -----------------
	// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
	// They do not themselves have any side-effects; they just describe something that is going to happen.

	public productFormUpNav<T>(entity: T, title: string, text: string, key: string, previous?: BreadcrumbItem<any>): IProductFormUpNavAction<T> {
		return {
			entity,
			key,
			text,
			title,
			type: "PRODUCT_FORM_UP_NAVIGATION",
			previous,
		};
	}

	public productFormDownNav<T>(entity: T): IProductFormDownNavAction<T> {
		return {
			entity,
			type: "PRODUCT_FORM_DOWN_NAVIGATION",
		};
	}

	public productFormRelationshipLoaded<T, K>(entity: T, entities: K | K[], parentEntityProperty: keyof T): IProductFormRelationshipLoaded<T, K> {
		return {
			entities,
			entity,
			parentEntityProperty,
			type: "PRODUCT_FORM_RELATIONSHIP_LOADED",
		};
	}

	public clearStore(): IProductFormClearStoreAction {
		return {
			type: "PRODUCT_FORM_CLEAR_STORE",
		};
	}
}

// ----------------
// ACTION CREATORS - These are functions exposed to UI components that will trigger a state transition.
// They don't directly mutate state, but they can have external side-effects (such as loading data).

export const actionCreators = new ProductFormNavActions();



// WEBPACK FOOTER //
// ./src/store/products/product-form-nav-actions.ts